import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { ICustomerDto } from 'src/app/contracts';
import { Api } from 'src/app/core/common/api';
import { Auth } from 'src/app/core/common/auth';
import { Language } from 'src/app/core/contracts';

@Injectable()
export class Identity {
  private roles: string[] = [];
  private api = inject(Api);
  private auth = inject(Auth);
  constructor() {
    this.init();
  }
  private init() {
    this.auth.isAuthenticated$
      .pipe(
        switchMap(isAuthenticated => {
          if (isAuthenticated) {
            return this.auth.getRoles();
          }
          return of<string[]>([]);
        })
      )
      .subscribe(roles => (this.roles = roles));
  }
  public changePassword(oldPass: string, newPass: string) {
    return this.api.post(this.api.baseUrl + 'api/users/change-password', { oldPassword: oldPass, newPassword: newPass }, { appendBaseUrl: false });
  }
  public resetPassword(username: string) {
    return this.api.post(this.api.baseUrl + 'api/users/reset-password', { userName: username }, { appendBaseUrl: false });
  }
  public verifyPasswordReset(token: string, username: string, newPassword: string) {
    return this.api.post(this.api.baseUrl + 'api/users/reset-password', { token, newPassword, userName: username }, { appendBaseUrl: false });
  }
  public hasEmail(): Observable<boolean> {
    return this.api.get<ICustomerDto>('users/profile', { handleLoading: false }).pipe(map((profile: ICustomerDto) => !!profile.email?.trim()));
  }
  public setEmail(email: string): Observable<void> {
    return this.api.post('users/email', { email });
  }
  public setLanguage(language: Language) {
    return this.api.post('users/language', { language: Language[language] });
  }
}
